import { Character } from "./character.class";
import { DraggableItemObj } from "./draggable-item.class";

export class Figure extends Character {
  constructor(obj: Omit<DraggableItemObj, "type">, imgUrl: string) {
    super(obj, imgUrl);
    this.type = "figures";
  }
}
